export const RESET_FILTERS_BUTTON_LABEL = 'Reset all filters';
